import React, { Component } from 'react';
import update from 'immutability-helper';
import TextField from '../global/fields/TextField';
import { languages } from '../../constants/language';
import Button from '../global/Button';
import { Portal, UpdatePreferredLanguage, UpdateNationality, UpdateReligion } from '../../components';
import { jwtDecode } from 'jwt-decode';
import './styles.scss';
import { Avatar } from 'antd';
import { getHeaders } from '../../api/helpers';
import { apiUrl } from '../../constants/apiConsts';

import UserPlaceholder from '../../assets/images/user_placeholder.svg';
import SelectField from '../global/fields/SelectField';
import CheckboxField from '../global/fields/Checkbox';

import { extractTags } from './userTagsUtils';
import { logFirebaseEvent } from '../../firebase/analytics';
import AddIcon from '../../components/Icons/AddIcon';
class EditUserProfile extends Component {
  constructor(props) {
    super(props);

    const userProfileInitinal = jwtDecode(this.props.token.key);
    const userProfile = JSON.parse(localStorage.getItem('user'));

    const userName =
      userProfile === null ? userProfileInitinal.first_name : userProfile.user.first_name;
    const lastName =
      userProfile === null ? userProfileInitinal.last_name : userProfile.user.last_name;
    const phone =
      userProfile === null ? userProfileInitinal.phone_number : userProfile.user.phone_number;
    const preferred_language =
      userProfile === null ? userProfileInitinal.language_id : userProfile.user.language_id;
    const nationality =
      userProfile === null ? userProfileInitinal.nationality_id : userProfile.user.nationality_id;
    const nationalityName =
      userProfile === null
        ? userProfileInitinal.nationality_name
        : userProfile.user.nationality_name;
    const religion =
      userProfile === null ? userProfileInitinal.religion_id : userProfile.user.religion_id;
    const religion_name =
      userProfile === null ? userProfileInitinal.religion_name : userProfile.user.religion_name;
    const trustName =
      userProfile === null ? userProfileInitinal.trust_name : userProfile.user.trust_name;
    const jobTitle =
      userProfile === null ? userProfileInitinal.job_title : userProfile.user.job_title;
    const department_id =
      userProfile === null ? userProfileInitinal.department_id : userProfile.user.department_id;
    const description =
      userProfile === null ? userProfileInitinal.description : userProfile.user.description;
    const contactLink =
      userProfile === null ? userProfileInitinal.contact_link : userProfile.user.contact_link;

    let preferred_language_name = '';
    if (preferred_language) {
      const language = languages.filter((item) => item.id === preferred_language);
      preferred_language_name = language.length ? language[0].name : ' ';
    }

    this.state = {
      form: {
        fields: {
          first_name: {
            label: 'First Name *',
            value: userName,
            type: 'text',
            validateRule: 'requiredMax64',
          },
          last_name: {
            label: 'Last Name *',
            value: lastName,
            type: 'text',
            validateRule: 'requiredMax64',
          },
          job_title: {
            label: 'Job Title *',
            value: jobTitle,
            type: 'text',
            validateRule: 'requiredMax64',
          },
          phone_number: {
            label: 'Phone no. (optional)',
            value: phone,
            type: 'number',
          },
          nationality: {
            label: 'Nationality *',
            value: nationality,
            displayName: nationalityName,
            type: 'text',
            validateRule: 'required',
            displayFlag: null,
          },
          preferred_language: {
            label: 'Preferred Language *',
            value: preferred_language,
            displayName: preferred_language_name,
            type: 'text',
            validateRule: 'required',
          },
          religion: {
            label: 'Religion (Optional)',
            value: religion,
            displayName: religion_name,
            type: 'text',
          },
          trustName: {
            label: 'Trust *',
            value: trustName,
            type: 'text',
            readOnly: true,
          },
          department_id: {
            label: 'Department *',
            value: department_id,
            type: 'dropdown',
            validateRule: 'name',
          },
          description: {
            label: 'Description *',
            value: description,
            type: 'textarea',
            fieldTag: "textarea",
            rows: "3",
            validateRule: "max512"
          },
          contact_link: {
            label: 'Contact Link *',
            value: contactLink,
            type: 'text',
            validateRule: "max256"
          },
        },
        validate: false,
      },
      imageBlobUrl: '',
      imageFile: null,
      showValidateBlock: false,
      validationBlockInputs: [],
      userProfileData: [],
      firstName: '',
      lastName: '',
      jobTitle: '',
      nationality: '',
      religion: '',
      preferred_language: '',
      phoneNumber: '',
      avatar: '',
      saveSuccessfully: false,
      showUpdatePreferredLanguage: false,
      showUpdateNationality: false,
      showUpdateGender: false,
      nationalities: [],
      nationalityFlag: null,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.updateFieldValue = this.updateFieldValue.bind(this);
  }

  fetchNationalities = async () => {
    const res = await fetch(`${apiUrl}/content/nationality_list`, {
      method: 'GET',
      headers: getHeaders(),
    });
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    return res.json();
  };

  componentDidMount() {
    this.dispatchInitialActions();

    const userProfileInitinal = jwtDecode(this.props.token.key);
    const id = userProfileInitinal.avatar;

    this.props.handleUser({ token: this.props.token.key });

    // Get Nationalities
    setTimeout(() => {
      this.fetchNationalities()
      .then(data => {
        if (data?.nationalities) {
          this.setState(prev => {
            const nationalityId = prev.form?.fields?.nationality?.value;
            const match = data.nationalities.find(n => n.id === nationalityId);
            return {
              nationalities: data.nationalities.map(country => ({
                value: country.id,
                label: country.name,
                displayName: country.name,
                flag: country.flag_icon,
              })),
              form: {
                ...prev.form,
                fields: {
                  ...prev.form.fields,
                  nationality: {
                    ...prev.form.fields.nationality,
                    displayFlag: match ? match.flag_icon : null,
                  },
                },
              },
            };
          });
        }
      })
      .catch(err => console.error(err));
      // Make sure to trigger API call after TextField is rendered to display the flag
    }, 1000);

    this.setState({
      firstName: userProfileInitinal.first_name,
      lastName: userProfileInitinal.last_name,
      phoneNumber: userProfileInitinal.phone_number,
      jobTitle: userProfileInitinal.job_title,
      preferredLanguage: userProfileInitinal.preferred_language,
      nationality: userProfileInitinal.nationality,
      religion: userProfileInitinal.religion,
      trustName: userProfileInitinal.trust_name,
      avatar: id,
    });
  }

  componentWillReceiveProps(nextProps) {
    const formFields = Object.assign({}, this.state.form.fields);

    if (nextProps.userData && nextProps.userData.image && nextProps.userData.image.url) {
      if (this.state.avatar !== nextProps.userData.image_id) {
        this.setState({ avatar: nextProps.userData.image_id });
        this.props.handleAvatar(nextProps.userData.image.url);
      }
    }

    const newFormFields = { ...formFields };

    this.setState((state) =>
      update(state, {
        form: {
          fields: { $set: newFormFields },
        },
        imageBlobUrl: { $set: this.state.imageBlobUrl },
      }),
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userTags.length !== this.props.userTags.length) {
      this.setupUserTagFields(this.props.userTags);
    }
  }

  dispatchInitialActions = () => {
    setTimeout(() => {
      this.props.getDepartments();
      this.props.getUserTags();
    }, 0);
  };

  setupUserTagFields = (userTags) => {
    const {
      form,
      form: { fields },
    } = this.state;

    const userTagFields = userTags.map((tag) => {
      const id = `tag-${tag.id}`;

      if (tag.type === 1) {
        const selected = tag.options.find((option) => option.is_selected) || {};
        return {
          id,
          label: tag.title,
          value: selected.id,
          type: 'dropdown',
          validateRule: 'optional',
        };
      } else if (tag.type === 2) {
        const [checkbox] = tag.options;
        return {
          id,
          label: checkbox.label,
          value: checkbox.is_selected,
          type: 'checkbox',
          validateRule: 'optional',
        };
      } else return {};
    });

    const userTagObject = userTagFields.reduce((acc, value) => {
      acc[value.id] = value;
      return acc;
    }, {});

    const newState = {
      form: {
        ...form,
        fields: {
          ...fields,
          ...userTagObject,
        },
      },
    };

    this.setState(newState);
  };

  handleModal = () => {
    this.setState({
      saveSuccessfully: !this.state.saveSuccessfully,
    });
  };

  togglePreferredLanguage = () => {
    this.setState({
      showUpdatePreferredLanguage: !this.state.showUpdatePreferredLanguage,
    });
  };

  toggleNationality = () => {
    this.setState({
      showUpdateNationality: !this.state.showUpdateNationality,
    });
  };

  toggleReligion = () => {
    this.setState({
      showUpdateReligion: !this.state.showUpdateReligion,
    });
  };

  updateFieldValue(fk, value, error, displayName, displayFlag) {
    this.setState((state) =>
      update(state, {
        form: {
          fields: {
            [fk]: {
              value: { $set: value },
              displayName: { $set: displayName },
              displayFlag: { $set: displayFlag },
              error: { $set: error },
            },
          },
        },
        showValidateBlock: { $set: false },
      }),
    );
  }

  onSubmit() {
    this.setState(
      (state) =>
        update(state, {
          form: {
            validate: { $set: true },
          },
        }),
      () => {
        const { fields } = this.state.form;
        const data = {};

        // Get errors
        const validationBlockInputs = [];
        Object.values(fields).forEach((item) => {
          if (item.hasOwnProperty('validateRule') && item.error) {
            validationBlockInputs.push(item.label);
          }

          if (item.label === 'Preferred Language' && (!item.value || item.value.length === 0)) {
            validationBlockInputs.push(item.label);
          }

          if (item.label === 'Nationality' && (!item.value || item.value.length === 0)) {
            validationBlockInputs.push(item.label);
          }
        });

        // Not valid
        if (validationBlockInputs.length) {
          return this.setState({ showValidateBlock: true, validationBlockInputs });
        }

        Object.keys(fields).map((key) => (data[key] = fields[key].value));
        const tags = extractTags(fields, this.props.userTags);
        logFirebaseEvent({
          event: 'profile',
          action: 'update',
        });

        this.props.updateProfile({ ...data, tags, token: this.props.token.key });

        if (this.state.imageBlobUrl !== '') {
          this.props.postUserAvatar({ image: this.state.imageFile, token: this.props.token.key });
          this.props.updateProfile({ ...data, token: this.props.token.key });

          const imageId = JSON.parse(localStorage.getItem('imageId'));

          this.props.handleAvatar({ token: this.props.token.key, id: imageId });
        }
      },
    );
    this.handleModal();
  }

  _renderField(key, filledValue) {
    const { type, placeholder, label, validateRule, value, error, helperText, readOnly, rows, fieldTag } =
      this.state.form.fields[key];

    return (
      <TextField
        key={key}
        fk={key}
        type={type}
        label={label}
        fieldTag={fieldTag}
        readOnly={readOnly}
        rows={rows}
        placeholder={placeholder}
        helperText={helperText}
        value={value}
        validateRule={validateRule}
        validateObj={{ [validateRule]: value }}
        error={error}
        showError={this.state.form.validate}
        updateFieldData={this.updateFieldValue}
      />
    );
  }

  _renderSelect = ({ key, options, label }) => {
    const { validateRule, value, error } = this.state.form.fields[key];

    return (
      <SelectField
        placeholder={label}
        options={options}
        key={key}
        fk={key}
        value={value}
        validateRule={validateRule}
        validateObj={{ [validateRule]: value }}
        error={error}
        showError={this.state.form.validate}
        updateFieldData={this.updateFieldValue}
      />
    );
  };

  _renderCheckbox = (key) => {
    const { value, label } = this.state.form.fields[key];
    return (
      <CheckboxField
        key={key}
        fk={key}
        value={value}
        label={label}
        updateFieldData={this.updateFieldValue}
      />
    );
  };

  _renderUserTags = () => {
    const { userTags } = this.props;
    return userTags.map(({ type, id, options, title }) => {
      const key = `tag-${id}`;
      if (!this.state.form.fields[key]) return null;
      if (type === 1)
        return this._renderSelect({
          key,
          label: title,
          options: options.map((value) => ({
            value: value.id,
            displayName: value.label,
          })),
        });
      if (type === 2) return this._renderCheckbox(key);
      else return null;
    });
  };

  _renderModal = (key, toggle) => {
    const { type, placeholder, label, validateRule, value, error, helperText, displayName, displayFlag } =
      this.state.form.fields[key];

    return (
      <div onClick={toggle}>
        <TextField
          key={key}
          fk={key}
          value={displayName}
          type={type}
          label={label}
          placeholder={placeholder}
          helperText={helperText}
          validateRule={validateRule}
          validateObj={{ [validateRule]: value }}
          error={error}
          nationalityFlag={displayFlag}
          showError={this.state.form.validate}
          updateFieldData={(fk, values, error) => {
            this.updateFieldValue(fk, value, error, displayName, displayFlag);
          }}
        />
      </div>
    );
  };

  render() {
    return (
      <div className="container-fluid on-boarding">
        <div>{this.renderForm(this.state)}</div>
      </div>
    );
  }

  renderForm({
    firstName,
    lastName,
    phoneNumber,
    jobTitle,
  }) {
    let image;
    image = (
      <Avatar
        className="user-profile-avatar"
        alt="avatar"
        src={this.props.avatarImg || UserPlaceholder}
        shape="square"
        size={97}
        icon="user"
      />
    );

    if (this.state.imageBlobUrl) {
      image = (
        <img
          className="upload-img user-profile-avatar"
          alt="avatar"
          src={this.state.imageBlobUrl}
        />
      );
    }

    return (
      <div
        className="form-holder edit-profile-container offset-md-3 offset-xl-4"
        style={{ marginTop: '0px', maxWidth: 600 }}
      >
        <div>
          <input
            ref={(e) => (this.input = e)}
            className="d-none"
            type="file"
            accept="image/x-png,image/jpeg,image/gif"
            onChange={(e) => {
              this.setState({
                imageFile: e.target.files[0],
                imageBlobUrl: URL.createObjectURL(e.target.files[0]),
              });
            }}
          />

          <div className="upload-img-holder" onClick={() => this.input.click()}>
            {image}
            <AddIcon className="add-img" />
          </div>

          <p className="picture-text mt-4 mb-3">Profile picture</p>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.onSubmit();
            }}
          >
            {this._renderField('first_name', firstName)}
            {this._renderField('last_name', lastName)}
            {this._renderField('job_title', jobTitle)}
            {this._renderField('phone_number', phoneNumber)}
            {this._renderModal('nationality', () => this.toggleNationality())}
            {this._renderModal('preferred_language', () => this.togglePreferredLanguage())}
            {this._renderModal('religion', () => this.toggleReligion())}
            {this._renderField('trustName')}
            {this._renderField('description')}
            {this._renderField('contact_link')}
            {this._renderSelect({
              key: 'department_id',
              label: 'Department',
              options: this.props.departments.map((value) => ({
                value: value.id,
                displayName: value.department,
              })),
            })}
            {this._renderUserTags()}
            <p className="form-text phone-warning">
              If you enter your phone number it will be visible when a colleague visits your profile
            </p>
            {this.state.showValidateBlock ? (
              <>
                <div className="validate-block">
                  <p>Looks like you made some mistakes, check the following fields:</p>
                  <ul>
                    {this.state.validationBlockInputs.map((input) => (
                      <li key={input}>{input}</li>
                    ))}
                  </ul>
                </div>
              </>
            ) : null}
          </form>

          <div className="save-button-container">
            <div className="save-button-inner-container">
              <Button.Primary onClick={this.onSubmit} type="submit">
                SAVE
              </Button.Primary>
            </div>
          </div>
        </div>
        <Portal
          hide={() => this.toggleReligion(false)}
          isOpen={this.state.showUpdateReligion}
          minWidth={710}
        >
          <UpdateReligion
            hide={() => this.toggleReligion(false)}
            value={this.state.form.fields.religion.value}
            fk={'religion'}
            updateFieldData={this.updateFieldValue}
          />
        </Portal>
        <Portal
          hide={() => this.togglePreferredLanguage(false)}
          isOpen={this.state.showUpdatePreferredLanguage}
          minWidth={710}
        >
          <UpdatePreferredLanguage
            hide={() => this.togglePreferredLanguage(false)}
            value={this.state.form.fields.preferred_language.value}
            fk={'preferred_language'}
            updateFieldData={this.updateFieldValue}
          />
        </Portal>
        <Portal
          hide={() => this.toggleNationality()}
          isOpen={this.state.showUpdateNationality}
          minWidth={710}
        >
          <UpdateNationality
            hide={() => this.toggleNationality()}
            value={this.state.form.fields.nationality.value}
            fk={'nationality'}
            updateFieldData={this.updateFieldValue}
          />
        </Portal>
      </div>
    );
  }
}

export default EditUserProfile;
